var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRideset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "835421CD-3915-42F4-B16B-82C41E9062EB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rides---Reservations",
    transform: "translate(-345.000000, -371.000000)",
    stroke: "#A1A5B3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "row-copy",
    transform: "translate(149.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(194.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-icon/ride-id-copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 7.000000)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "11.0317383 0 13.2631579 0 13.2631579 12.9044118 0 12.9044118 0 11.1088867"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinejoin: "round",
    x: 3.36842105,
    y: 2.4375,
    width: 13.2631579,
    height: 13.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85964092,12.1492667 C7.09589628,10.0497556 8.14854326,9 10.0175819,9 C11.8866205,9 12.8807599,8.0480957 13,6.14428711",
    id: "Path-3"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRideset);
export default __webpack_public_path__ + "static/media/rideset.eba088c2cca6d9a345ad0a50bce69c86.svg";
export { ForwardRef as ReactComponent };